
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../../main/components/nav-left/nav-left.vue";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import { GetSources, SaveSource, DelSource } from "@/request/setting";
import { ZuzhijiagouList } from "@/request/doctor";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class Name extends mixins(listMixin) {
  // private H: any = "";
  private zhuangtais: any = ["正常", "禁用"];
  private data: any = [];
  private ifShowEdit: any = false;
  private ifShowMa: any = false;
  private maUrl: any = {};
  private type: any = "";
  private editMsg: any = {};
  private institutions: any[] = [];
  private get configuration() {
    return this.$store.state.configuration;
  }
  private preview(url: any) {
    window.open(url);
  }
  /**
   * @description 获得可选的组织结构列表
   */
  private getZuzhijiagouList() {
    return new Promise((resolve, reject) => {
      ZuzhijiagouList(this, {})
        .then((data: any) => {
          this.institutions = data;
          resolve(data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  private downloadIamge(imgsrc: any, name: any) {
    //下载图片地址和图片名
    var image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function () {
      var canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      var context: any = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

      var a = document.createElement("a"); // 生成一个a元素
      var event = new MouseEvent("click"); // 创建一个单击事件
      a.download = name || "photo"; // 设置图片名称
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
    };
    image.src = imgsrc;
  }
  private xiazai() {
    this.downloadIamge(this.maUrl["二维码"], this.maUrl["来源名称"]);
  }
  private downLoad(item: any) {
    if (item["状态"] !== "正常") {
      this.$message.warning("该来源禁用状态，二维码不可使用！");
      return;
    }
    this.maUrl = item;
    this.ifShowMa = true;
  }
  private addSource() {
    this.type = "新建";
    this.editMsg = {};
    this.ifShowEdit = true;
  }
  private editSource(item: any) {
    if (item["状态"] !== "正常") {
      this.$message.warning("该来源禁用状态，不可编辑！");
      return;
    }
    this.type = "编辑";
    this.editMsg = JSON.parse(JSON.stringify(item));
    this.ifShowEdit = true;
  }
  private delOne(item: any) {
    this.$confirm("您确定删除该来源么？")
      .then(() => {
        const params: any = {
          source_id: item.source_id,
        };
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        DelSource(this, params)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功!");
            this.getList();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private save() {
    if (!this.editMsg["来源名称"]) {
      this.$message.warning("来源名称必填");
      return;
    }
    if (this.editMsg["来源名称"].length > 30) {
      this.$message.warning("来源名称长度不能超过30");
      return;
    }
    if (!this.editMsg["英文简写"]) {
      this.$message.warning("英文简写必填");
      return;
    }
    // if (!this.editMsg["小程序页"]) {
    //   this.$message.warning("小程序页必选");
    //   return;
    // }
    if (!this.editMsg["institution_id"]) {
      this.$message.warning("请选择需要绑定的机构");
      return;
    }
    if (!this.editMsg["状态"]) {
      this.editMsg["状态"] = "正常";
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    SaveSource(this, this.editMsg, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success(this.type + "成功！");
        this.ifShowEdit = false;
        this.getList();
        this.maUrl = res;
        this.ifShowMa = true;
      })
      .catch((error: any) => {
        loading.close();
      });
  }
  private statusChange(item: any, val: any) {
    this.type = val;
    this.editMsg = JSON.parse(JSON.stringify(item));
    if (val == "禁用") {
      this.editMsg["状态"] = "禁用";
    } else {
      this.editMsg["状态"] = "正常";
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    SaveSource(this, this.editMsg)
      .then((res: any) => {
        loading.close();
        this.$message.success(this.type + "成功！");
        this.ifShowEdit = false;
        this.search();
      })
      .catch(() => {
        loading.close();
      });
  }
  getList() {
    const params: any = {
      search: this.filters.search,
      状态: this.filters["状态"],
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
      sort_value: this.filters.sort_value,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    localStorage.setItem("sourceFilter", JSON.stringify(this.filters));
    GetSources(this, params)
      .then((data: any) => {
        loading.close();
        this.data = data.datas;
        this.filters.total_count = data.total_count;
        this.filters.total_page = data.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_value = 1;
    if (localStorage.getItem("sourceFilter")) {
      this.filter = JSON.parse(localStorage.getItem("sourceFilter") as any);
    }
    this.getList();
    this.getZuzhijiagouList();
    // this.H = document.body.clientHeight - 114;
  }
}
